export enum IfcCategorizationStrategy {
  'Presentation',
  'Building Name',
  'Element Name',
}
